import React, { useState, useEffect } from "react";
import { useConfig } from "../context";
import { obtieneFamiliaProductos } from "../repository";
import Modal360Viewer from "../components/Product360ViewerPromo";

const ProductItems = (props) => {
  const { fotos360Url } = useConfig();
  const [loading, setLoading] = useState(true);
  const [productosFamilia, setProductosFamilia] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const obtieneProductosFam = (idFamilia) => {
    obtieneFamiliaProductos(idFamilia)
      .then((response) => {
        if (response.status === 200) {
          setProductosFamilia(response.data.result);
        } else {
          alert("Error obtener la información");
          setProductosFamilia([]);
        }
      })
      .catch(
        (err) => alert("Error obtener la información" + err),
        setProductosFamilia([])
      );
  };

  useEffect(() => {
    obtieneProductosFam(props.idFamilia);
   
    setLoading(false);
  }, [props.idFamilia]);

  const open360Viewer = (idFamilia, index) => {
    setSelectedFamily(idFamilia);
    setSelectedIndex(index);
  };

  const close360Viewer = () => {
    //console.log("close modal")
    setSelectedFamily(null);
    setSelectedIndex(null);
  };

  return (
    <div className="row mt-3" key={props.idFamilia + props.Codigo}>
      {loading ? (
        <div className="col-md-12 text-center">
          <p>Cargando...</p>
          <div
            className="spinner-border text-warning"
            role="status"
            aria-hidden="true"
          ></div>
        </div>
      ) : (
        productosFamilia.map((item, index) => (
          <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
            <div className="product-card-modern">
              <div
                className="product-card-image-wrapper"
                onClick={() => open360Viewer(item.idFamilia, index)}
              >
                <img
                  src={fotos360Url + item.DefaultImage}
                  alt={item.Codigo}
                  className="product-card-image"
                />
                <div className="product-card-action">
                  <i className="fa-solid fa-arrows-rotate"></i>
                  <span>Ver 360°</span>
                </div>
              </div>
              {selectedFamily === item.idFamilia && selectedIndex === index && (
                <Modal360Viewer
                  index={index}
                  item={item}
                  closeModal={close360Viewer}
                />
              )}
              <div className="product-card-footer">
                <h6 className="product-card-title">{item.Familia}</h6>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
};

export default ProductItems;
